/**
 * Generated by orval v8.0.0-rc.2 🍺
 * Do not edit manually.
 * SEMO API
 * ## SEMO MVP REST API

한국 서비스 마켓플레이스 백엔드 API 문서. 인증, 채팅, 견적, 계약, 결제를 포함합니다.

**버전**: `v0.1.0`
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  CreateQuoteResponseVersionDto,
  QuoteResponsesControllerCreate201,
  QuoteResponsesControllerDownloadPdf200,
  QuoteResponsesControllerFindOne200,
  QuoteResponsesControllerUploadAttachments201,
  QuoteResponsesControllerUploadAttachmentsBody,
  QuoteResponsesControllerWithdraw200,
  WithdrawQuoteResponseDto,
} from "../client.schemas";

import { api } from "../../lib/orval-mutator";
import type { ErrorType, BodyType } from "../../lib/orval-mutator";

/**
 * @summary 견적 응답 생성 (공급자 전용)
 */
export const quoteResponsesControllerCreate = (
  quoteRequestId: string,
  createQuoteResponseVersionDto: BodyType<CreateQuoteResponseVersionDto>,
  signal?: AbortSignal,
) => {
  return api<QuoteResponsesControllerCreate201>({
    url: `/quote-responses/quote-request/${quoteRequestId}`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createQuoteResponseVersionDto,
    signal,
  });
};

export const getQuoteResponsesControllerCreateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof quoteResponsesControllerCreate>>,
    TError,
    { quoteRequestId: string; data: BodyType<CreateQuoteResponseVersionDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof quoteResponsesControllerCreate>>,
  TError,
  { quoteRequestId: string; data: BodyType<CreateQuoteResponseVersionDto> },
  TContext
> => {
  const mutationKey = ["quoteResponsesControllerCreate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof quoteResponsesControllerCreate>>,
    { quoteRequestId: string; data: BodyType<CreateQuoteResponseVersionDto> }
  > = (props) => {
    const { quoteRequestId, data } = props ?? {};

    return quoteResponsesControllerCreate(quoteRequestId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type QuoteResponsesControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof quoteResponsesControllerCreate>>
>;
export type QuoteResponsesControllerCreateMutationBody =
  BodyType<CreateQuoteResponseVersionDto>;
export type QuoteResponsesControllerCreateMutationError = ErrorType<unknown>;

/**
 * @summary 견적 응답 생성 (공급자 전용)
 */
export const useQuoteResponsesControllerCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof quoteResponsesControllerCreate>>,
      TError,
      { quoteRequestId: string; data: BodyType<CreateQuoteResponseVersionDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof quoteResponsesControllerCreate>>,
  TError,
  { quoteRequestId: string; data: BodyType<CreateQuoteResponseVersionDto> },
  TContext
> => {
  const mutationOptions =
    getQuoteResponsesControllerCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 견적 철회 (공급자 전용)
 */
export const quoteResponsesControllerWithdraw = (
  id: string,
  withdrawQuoteResponseDto?: BodyType<WithdrawQuoteResponseDto>,
  signal?: AbortSignal,
) => {
  return api<QuoteResponsesControllerWithdraw200>({
    url: `/quote-responses/${id}/withdraw`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: withdrawQuoteResponseDto,
    signal,
  });
};

export const getQuoteResponsesControllerWithdrawMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof quoteResponsesControllerWithdraw>>,
    TError,
    { id: string; data: BodyType<WithdrawQuoteResponseDto> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof quoteResponsesControllerWithdraw>>,
  TError,
  { id: string; data: BodyType<WithdrawQuoteResponseDto> },
  TContext
> => {
  const mutationKey = ["quoteResponsesControllerWithdraw"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof quoteResponsesControllerWithdraw>>,
    { id: string; data: BodyType<WithdrawQuoteResponseDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return quoteResponsesControllerWithdraw(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type QuoteResponsesControllerWithdrawMutationResult = NonNullable<
  Awaited<ReturnType<typeof quoteResponsesControllerWithdraw>>
>;
export type QuoteResponsesControllerWithdrawMutationBody =
  BodyType<WithdrawQuoteResponseDto>;
export type QuoteResponsesControllerWithdrawMutationError = ErrorType<unknown>;

/**
 * @summary 견적 철회 (공급자 전용)
 */
export const useQuoteResponsesControllerWithdraw = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof quoteResponsesControllerWithdraw>>,
      TError,
      { id: string; data: BodyType<WithdrawQuoteResponseDto> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof quoteResponsesControllerWithdraw>>,
  TError,
  { id: string; data: BodyType<WithdrawQuoteResponseDto> },
  TContext
> => {
  const mutationOptions =
    getQuoteResponsesControllerWithdrawMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 견적 응답 상세 조회
 */
export const quoteResponsesControllerFindOne = (
  id: string,
  signal?: AbortSignal,
) => {
  return api<QuoteResponsesControllerFindOne200>({
    url: `/quote-responses/${id}`,
    method: "GET",
    signal,
  });
};

export const getQuoteResponsesControllerFindOneQueryKey = (id?: string) => {
  return [`/quote-responses/${id}`] as const;
};

export const getQuoteResponsesControllerFindOneQueryOptions = <
  TData = Awaited<ReturnType<typeof quoteResponsesControllerFindOne>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof quoteResponsesControllerFindOne>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getQuoteResponsesControllerFindOneQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof quoteResponsesControllerFindOne>>
  > = ({ signal }) => quoteResponsesControllerFindOne(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof quoteResponsesControllerFindOne>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type QuoteResponsesControllerFindOneQueryResult = NonNullable<
  Awaited<ReturnType<typeof quoteResponsesControllerFindOne>>
>;
export type QuoteResponsesControllerFindOneQueryError = ErrorType<unknown>;

export function useQuoteResponsesControllerFindOne<
  TData = Awaited<ReturnType<typeof quoteResponsesControllerFindOne>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof quoteResponsesControllerFindOne>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof quoteResponsesControllerFindOne>>,
          TError,
          Awaited<ReturnType<typeof quoteResponsesControllerFindOne>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useQuoteResponsesControllerFindOne<
  TData = Awaited<ReturnType<typeof quoteResponsesControllerFindOne>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof quoteResponsesControllerFindOne>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof quoteResponsesControllerFindOne>>,
          TError,
          Awaited<ReturnType<typeof quoteResponsesControllerFindOne>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useQuoteResponsesControllerFindOne<
  TData = Awaited<ReturnType<typeof quoteResponsesControllerFindOne>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof quoteResponsesControllerFindOne>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 견적 응답 상세 조회
 */

export function useQuoteResponsesControllerFindOne<
  TData = Awaited<ReturnType<typeof quoteResponsesControllerFindOne>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof quoteResponsesControllerFindOne>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getQuoteResponsesControllerFindOneQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 견적서 PDF 다운로드 URL 조회 (즉시 생성 지원)
 */
export const quoteResponsesControllerDownloadPdf = (
  versionId: string,
  signal?: AbortSignal,
) => {
  return api<QuoteResponsesControllerDownloadPdf200>({
    url: `/quote-responses/versions/${versionId}/download`,
    method: "GET",
    signal,
  });
};

export const getQuoteResponsesControllerDownloadPdfQueryKey = (
  versionId?: string,
) => {
  return [`/quote-responses/versions/${versionId}/download`] as const;
};

export const getQuoteResponsesControllerDownloadPdfQueryOptions = <
  TData = Awaited<ReturnType<typeof quoteResponsesControllerDownloadPdf>>,
  TError = ErrorType<unknown>,
>(
  versionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof quoteResponsesControllerDownloadPdf>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getQuoteResponsesControllerDownloadPdfQueryKey(versionId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof quoteResponsesControllerDownloadPdf>>
  > = ({ signal }) => quoteResponsesControllerDownloadPdf(versionId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!versionId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof quoteResponsesControllerDownloadPdf>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type QuoteResponsesControllerDownloadPdfQueryResult = NonNullable<
  Awaited<ReturnType<typeof quoteResponsesControllerDownloadPdf>>
>;
export type QuoteResponsesControllerDownloadPdfQueryError = ErrorType<unknown>;

export function useQuoteResponsesControllerDownloadPdf<
  TData = Awaited<ReturnType<typeof quoteResponsesControllerDownloadPdf>>,
  TError = ErrorType<unknown>,
>(
  versionId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof quoteResponsesControllerDownloadPdf>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof quoteResponsesControllerDownloadPdf>>,
          TError,
          Awaited<ReturnType<typeof quoteResponsesControllerDownloadPdf>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useQuoteResponsesControllerDownloadPdf<
  TData = Awaited<ReturnType<typeof quoteResponsesControllerDownloadPdf>>,
  TError = ErrorType<unknown>,
>(
  versionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof quoteResponsesControllerDownloadPdf>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof quoteResponsesControllerDownloadPdf>>,
          TError,
          Awaited<ReturnType<typeof quoteResponsesControllerDownloadPdf>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useQuoteResponsesControllerDownloadPdf<
  TData = Awaited<ReturnType<typeof quoteResponsesControllerDownloadPdf>>,
  TError = ErrorType<unknown>,
>(
  versionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof quoteResponsesControllerDownloadPdf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 견적서 PDF 다운로드 URL 조회 (즉시 생성 지원)
 */

export function useQuoteResponsesControllerDownloadPdf<
  TData = Awaited<ReturnType<typeof quoteResponsesControllerDownloadPdf>>,
  TError = ErrorType<unknown>,
>(
  versionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof quoteResponsesControllerDownloadPdf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getQuoteResponsesControllerDownloadPdfQueryOptions(
    versionId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 견적서 PDF 스트리밍 (당사자 전용, 만료 없는 주소)
 */
export const quoteResponsesControllerStreamPdf = (
  versionId: string,
  signal?: AbortSignal,
) => {
  return api<void>({
    url: `/quote-responses/versions/${versionId}/pdf`,
    method: "GET",
    signal,
  });
};

export const getQuoteResponsesControllerStreamPdfQueryKey = (
  versionId?: string,
) => {
  return [`/quote-responses/versions/${versionId}/pdf`] as const;
};

export const getQuoteResponsesControllerStreamPdfQueryOptions = <
  TData = Awaited<ReturnType<typeof quoteResponsesControllerStreamPdf>>,
  TError = ErrorType<unknown>,
>(
  versionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof quoteResponsesControllerStreamPdf>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getQuoteResponsesControllerStreamPdfQueryKey(versionId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof quoteResponsesControllerStreamPdf>>
  > = ({ signal }) => quoteResponsesControllerStreamPdf(versionId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!versionId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof quoteResponsesControllerStreamPdf>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type QuoteResponsesControllerStreamPdfQueryResult = NonNullable<
  Awaited<ReturnType<typeof quoteResponsesControllerStreamPdf>>
>;
export type QuoteResponsesControllerStreamPdfQueryError = ErrorType<unknown>;

export function useQuoteResponsesControllerStreamPdf<
  TData = Awaited<ReturnType<typeof quoteResponsesControllerStreamPdf>>,
  TError = ErrorType<unknown>,
>(
  versionId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof quoteResponsesControllerStreamPdf>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof quoteResponsesControllerStreamPdf>>,
          TError,
          Awaited<ReturnType<typeof quoteResponsesControllerStreamPdf>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useQuoteResponsesControllerStreamPdf<
  TData = Awaited<ReturnType<typeof quoteResponsesControllerStreamPdf>>,
  TError = ErrorType<unknown>,
>(
  versionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof quoteResponsesControllerStreamPdf>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof quoteResponsesControllerStreamPdf>>,
          TError,
          Awaited<ReturnType<typeof quoteResponsesControllerStreamPdf>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useQuoteResponsesControllerStreamPdf<
  TData = Awaited<ReturnType<typeof quoteResponsesControllerStreamPdf>>,
  TError = ErrorType<unknown>,
>(
  versionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof quoteResponsesControllerStreamPdf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 견적서 PDF 스트리밍 (당사자 전용, 만료 없는 주소)
 */

export function useQuoteResponsesControllerStreamPdf<
  TData = Awaited<ReturnType<typeof quoteResponsesControllerStreamPdf>>,
  TError = ErrorType<unknown>,
>(
  versionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof quoteResponsesControllerStreamPdf>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getQuoteResponsesControllerStreamPdfQueryOptions(
    versionId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary 견적 응답 첨부파일 업로드 (공급자 전용, 최대 10개)
 */
export const quoteResponsesControllerUploadAttachments = (
  quoteResponsesControllerUploadAttachmentsBody: BodyType<QuoteResponsesControllerUploadAttachmentsBody>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  if (quoteResponsesControllerUploadAttachmentsBody.files !== undefined) {
    quoteResponsesControllerUploadAttachmentsBody.files.forEach((value) =>
      formData.append(`files`, value),
    );
  }

  return api<QuoteResponsesControllerUploadAttachments201>({
    url: `/quote-responses/attachments`,
    method: "POST",
    headers: { "Content-Type": "multipart/form-data" },
    data: formData,
    signal,
  });
};

export const getQuoteResponsesControllerUploadAttachmentsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof quoteResponsesControllerUploadAttachments>>,
    TError,
    { data: BodyType<QuoteResponsesControllerUploadAttachmentsBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof quoteResponsesControllerUploadAttachments>>,
  TError,
  { data: BodyType<QuoteResponsesControllerUploadAttachmentsBody> },
  TContext
> => {
  const mutationKey = ["quoteResponsesControllerUploadAttachments"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof quoteResponsesControllerUploadAttachments>>,
    { data: BodyType<QuoteResponsesControllerUploadAttachmentsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return quoteResponsesControllerUploadAttachments(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type QuoteResponsesControllerUploadAttachmentsMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof quoteResponsesControllerUploadAttachments>>
  >;
export type QuoteResponsesControllerUploadAttachmentsMutationBody =
  BodyType<QuoteResponsesControllerUploadAttachmentsBody>;
export type QuoteResponsesControllerUploadAttachmentsMutationError =
  ErrorType<unknown>;

/**
 * @summary 견적 응답 첨부파일 업로드 (공급자 전용, 최대 10개)
 */
export const useQuoteResponsesControllerUploadAttachments = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof quoteResponsesControllerUploadAttachments>>,
      TError,
      { data: BodyType<QuoteResponsesControllerUploadAttachmentsBody> },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof quoteResponsesControllerUploadAttachments>>,
  TError,
  { data: BodyType<QuoteResponsesControllerUploadAttachmentsBody> },
  TContext
> => {
  const mutationOptions =
    getQuoteResponsesControllerUploadAttachmentsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
